import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Stack, Typography } from "@mui/joy";

// Declare global google object for TypeScript
declare global {
  interface Window {
    google: any;
  }
}

const LoginPage: React.FC = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    // Load Google Sign-In script
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
          callback: handleCredentialResponse,
        });
        window.google.accounts.id.renderButton(
          document.getElementById("google-login-button"),
          {
            theme: "outline",
            size: "large",
          }
        );
        window.google.accounts.id.prompt();
      }
    };

    return () => {
      // Clean up script on component unmount
      const existingScript = document.querySelector(
        'script[src="https://accounts.google.com/gsi/client"]'
      );
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  const handleCredentialResponse = async (response: any) => {
    try {
      setError("");
      await login(response.credential);
      navigate("/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      setError("เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Stack direction="column" alignItems="center" justifyContent="center">
        <Typography
          level="h1"
          sx={{
            mb: 2,
          }}
        >
          MP101 Browser
        </Typography>

        {error && (
          <Typography
            level="body-md"
            color="danger"
            sx={{
              mb: 2,
            }}
          >
            {error}
          </Typography>
        )}
        <div id="google-login-button"></div>
      </Stack>
    </div>
  );
};

export default LoginPage;
